// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Toast component styles
 * Element Web inspired design
 */

.toast {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: white;
  border-radius: 8px;
  padding: 16px;
  min-width: 320px;
  max-width: 420px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
  opacity: 0;
  transform: translateX(-20px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;
}

/* Animation states */
.toast-visible {
  opacity: 1;
  transform: translateX(0);
}

.toast-exiting {
  opacity: 0;
  transform: translateX(-20px);
  pointer-events: none;
}

/* Position variants */
.toast-top-right {
  transform: translateX(20px);
}

.toast-top-right.toast-visible {
  transform: translateX(0);
}

.toast-top-right.toast-exiting {
  transform: translateX(20px);
}

.toast-bottom-left,
.toast-bottom-right {
  transform: translateY(20px);
}

.toast-bottom-left.toast-visible,
.toast-bottom-right.toast-visible {
  transform: translateY(0);
}

.toast-bottom-left.toast-exiting,
.toast-bottom-right.toast-exiting {
  transform: translateY(20px);
}

/* Type-specific colors */
.toast-info {
  border-left: 4px solid #007bff;
}

.toast-success {
  border-left: 4px solid #de4858;
}

.toast-warning {
  border-left: 4px solid #ffc107;
}

.toast-error {
  border-left: 4px solid #dc3545;
}

.toast-verification {
  border-left: 4px solid #667eea;
}

/* Icon */
.toast-icon {
  font-size: 24px;
  flex-shrink: 0;
  line-height: 1;
  user-select: none;
}

/* Content */
.toast-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.toast-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.toast-message {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

/* Actions */
.toast-actions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.toast-action-btn {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.toast-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.toast-action-primary {
  background: #667eea;
  color: white;
}

.toast-action-primary:hover:not(:disabled) {
  background: #5568d3;
}

.toast-action-secondary {
  background: #e9ecef;
  color: #495057;
}

.toast-action-secondary:hover:not(:disabled) {
  background: #dee2e6;
}

/* Close button */
.toast-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  line-height: 1;
}

.toast-close:hover {
  color: #333;
}

/* Responsive */
@media (max-width: 480px) {
  .toast {
    min-width: 280px;
    max-width: calc(100vw - 32px);
    margin-left: 16px;
    margin-right: 16px;
  }

  .toast-actions {
    flex-direction: column;
  }

  .toast-action-btn {
    width: 100%;
  }
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .toast {
    background: #2a2a2a;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1);
  }

  .toast-title {
    color: #e0e0e0;
  }

  .toast-message {
    color: #b0b0b0;
  }

  .toast-action-secondary {
    background: #3a3a3a;
    color: #e0e0e0;
  }

  .toast-action-secondary:hover:not(:disabled) {
    background: #4a4a4a;
  }

  .toast-close {
    color: #999;
  }

  .toast-close:hover {
    color: #fff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/Toast.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yEAAyE;EACzE,UAAU;EACV,4BAA4B;EAC5B,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,mBAAmB;IACnB,6EAA6E;EAC/E;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\n * Toast component styles\n * Element Web inspired design\n */\n\n.toast {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  min-width: 320px;\n  max-width: 420px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);\n  opacity: 0;\n  transform: translateX(-20px);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-bottom: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Animation states */\n.toast-visible {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.toast-exiting {\n  opacity: 0;\n  transform: translateX(-20px);\n  pointer-events: none;\n}\n\n/* Position variants */\n.toast-top-right {\n  transform: translateX(20px);\n}\n\n.toast-top-right.toast-visible {\n  transform: translateX(0);\n}\n\n.toast-top-right.toast-exiting {\n  transform: translateX(20px);\n}\n\n.toast-bottom-left,\n.toast-bottom-right {\n  transform: translateY(20px);\n}\n\n.toast-bottom-left.toast-visible,\n.toast-bottom-right.toast-visible {\n  transform: translateY(0);\n}\n\n.toast-bottom-left.toast-exiting,\n.toast-bottom-right.toast-exiting {\n  transform: translateY(20px);\n}\n\n/* Type-specific colors */\n.toast-info {\n  border-left: 4px solid #007bff;\n}\n\n.toast-success {\n  border-left: 4px solid #de4858;\n}\n\n.toast-warning {\n  border-left: 4px solid #ffc107;\n}\n\n.toast-error {\n  border-left: 4px solid #dc3545;\n}\n\n.toast-verification {\n  border-left: 4px solid #667eea;\n}\n\n/* Icon */\n.toast-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n  line-height: 1;\n  user-select: none;\n}\n\n/* Content */\n.toast-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.toast-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n  line-height: 1.4;\n}\n\n.toast-message {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.5;\n}\n\n/* Actions */\n.toast-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.toast-action-btn {\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.toast-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.toast-action-primary {\n  background: #667eea;\n  color: white;\n}\n\n.toast-action-primary:hover:not(:disabled) {\n  background: #5568d3;\n}\n\n.toast-action-secondary {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.toast-action-secondary:hover:not(:disabled) {\n  background: #dee2e6;\n}\n\n/* Close button */\n.toast-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #999;\n  cursor: pointer;\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n  line-height: 1;\n}\n\n.toast-close:hover {\n  color: #333;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .toast {\n    min-width: 280px;\n    max-width: calc(100vw - 32px);\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n\n  .toast-actions {\n    flex-direction: column;\n  }\n\n  .toast-action-btn {\n    width: 100%;\n  }\n}\n\n/* Dark theme support */\n@media (prefers-color-scheme: dark) {\n  .toast {\n    background: #2a2a2a;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1);\n  }\n\n  .toast-title {\n    color: #e0e0e0;\n  }\n\n  .toast-message {\n    color: #b0b0b0;\n  }\n\n  .toast-action-secondary {\n    background: #3a3a3a;\n    color: #e0e0e0;\n  }\n\n  .toast-action-secondary:hover:not(:disabled) {\n    background: #4a4a4a;\n  }\n\n  .toast-close {\n    color: #999;\n  }\n\n  .toast-close:hover {\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
